import { usePermissions } from './usePermissions';
import { BaseModel } from '@journeyapps-platform/lib-journey-core';
import { useEffect, useState } from 'react';
import { Resource, satisfies } from '@journeyapps-platform/types-cardinal';
import { System } from '../System';

export function useAllowed(params: {
  action: string;
  resource: BaseModel | null;
  comparativeResourceFactory?: () => Promise<Resource | null>;
}) {
  const permissions = usePermissions();
  const [isAllowed, setAllowed] = useState<boolean>(false);

  useEffect(() => {
    if (!permissions || (!params.resource && !params.comparativeResourceFactory)) {
      return;
    }
    (async () => {
      const { comparativeResourceFactory } = params;

      const targetResource = comparativeResourceFactory
        ? await comparativeResourceFactory()
        : await params.resource?.getComparativeResource();

      if (!targetResource) {
        console.error(`No comparative resource for`, params.resource, targetResource);
        return;
      }
      setAllowed(satisfies(permissions, params.action, targetResource));
    })();
  }, [permissions, params.resource]);

  return isAllowed;
}

export async function isAllowed(params: { system: System; action: string; resource: BaseModel }): Promise<boolean> {
  const { system } = params;
  const permissions = await system.loadUserPermissions();
  const compResource = await params.resource.getComparativeResource();
  return !compResource ? false : satisfies(permissions, params.action, compResource);
}
